import { Button } from "@heroui/react";
import { useNavigate } from "react-router-dom";
import { LuMoveLeft } from "react-icons/lu";

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="flex h-[80vh] flex-col items-center justify-center text-center">
            {/* Ambient Background Glow */}
            <div className="from-primary-500/20 to-secondary-500/20 dark:from-primary-500/10 dark:to-secondary-500/10 absolute top-1/2 left-1/2 -z-10 h-[500px] w-[500px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-gradient-to-tr opacity-50 blur-[100px]" />

            <h1 className="text-[150px] leading-none font-black tracking-tighter text-zinc-900/5 md:text-[250px] dark:text-white/5">
                404
            </h1>

            <div className="relative -mt-12 space-y-4 md:-mt-20">
                <h2 className="text-2xl font-bold tracking-tight text-zinc-800 md:text-4xl dark:text-zinc-100">
                    Page Not Found
                </h2>
                <p className="max-w-md text-zinc-500 dark:text-zinc-400">
                    The page you are looking for might have been removed, had
                    its name changed, or is temporarily unavailable.
                </p>

                <div className="pt-4">
                    <Button
                        color="primary"
                        startContent={<LuMoveLeft />}
                        onPress={() => navigate("/")}
                        className="font-semibold"
                    >
                        Back to Dashboard
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
